import { Select } from 'foundations-components/transitional/components/Select';
import EditorRelatedConditionsHeadingAssociationSelectValueComponent from './EditorRelatedConditionsHeadingAssociationSelectValueComponent';
import { useFlexibleAssociations } from '../../hooks/useFlexibleAssociations';
import { isObjectsAssociationOptionsGroup } from '../../types/ObjectsAssociationOptions';

// Utility function to convert ObjectsAssociationOptions to SelectProps['options']
import { jsx as _jsx } from "react/jsx-runtime";
const convertToSelectOptions = associationOptions => {
  return associationOptions.map(option => {
    if (isObjectsAssociationOptionsGroup(option)) {
      return {
        text: typeof option.text === 'string' ? option.text : String(option.text) || '',
        options: option.options.map(subOption => ({
          value: subOption.value,
          text: subOption.text || subOption.value,
          associatedObjectName: subOption.associatedObjectName
        }))
      };
    } else {
      return {
        value: option.value,
        text: option.text || option.value,
        associatedObjectName: option.associatedObjectName
      };
    }
  });
};

// Helper function to get first option value
const getFirstOptionValue = associationOptions => {
  if (associationOptions.length === 0) return undefined;
  const firstOption = associationOptions[0];
  if (isObjectsAssociationOptionsGroup(firstOption)) {
    var _firstOption$options$;
    return (_firstOption$options$ = firstOption.options[0]) === null || _firstOption$options$ === void 0 ? void 0 : _firstOption$options$.value;
  } else {
    return firstOption.value;
  }
};
const EditorCrmObjectAssociationSelect = props => {
  const {
    inputUse,
    logicGroup,
    conditionPath
  } = props;
  const {
    associationValue,
    associationOptions,
    onAssociationChange
  } = useFlexibleAssociations(logicGroup, conditionPath);
  const selectOptions = convertToSelectOptions(associationOptions);
  const selectValue = associationValue || getFirstOptionValue(associationOptions);
  return /*#__PURE__*/_jsx(Select, {
    menuWidth: "auto",
    onChange: evt => onAssociationChange(evt.target.value),
    options: selectOptions,
    value: selectValue,
    valueComponent: EditorRelatedConditionsHeadingAssociationSelectValueComponent,
    buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
  });
};
export default EditorCrmObjectAssociationSelect;